import { Button } from '@material-ui/core';
import React, { Component } from 'react'
import { GetData } from '../../api/service';
import moment from 'moment'

import ReactToPrint from 'react-to-print';
import { getGoodClass, getPhotoUrl } from '../IdCardRequest/cardFields';

export default class IdCardPrint extends Component {
    state = {
        id: '',
        student: {},
        request: null,
        isLoaded: false,
        photo: '',
        paymentDone: null

    }

    /**
     * When the page is opened from the ID Card Requests panel (requestId in the
     * URL) the request's own values win, because that is the data the student
     * supplied and the office verified. The student row is the fallback for any
     * field the request left blank, and the only source when there is no
     * requestId at all — which is how the legacy direct link keeps behaving
     * exactly as it did before.
     */
    field = (name) => {
        let request = this.state.request;

        if (request) {
            let value = request[name];
            if (value !== undefined && value !== null && String(value).trim() !== '') {
                return value;
            }
        }

        let value = this.state.student[name];
        return (value === undefined || value === null) ? '' : value;
    }


    getPhoto = (files) => {
        if (Array.isArray(files)) {
            let r = files.filter((el) => el.file_type == 'STUDENT_PHOTO')
            if (r.length > 0) {
                return r[0]['file_path']
            } else {
                return ''
            }
        } else {
            return ''
        }
    }

    /**
     * Same precedence as field(): the request wins. getPhotoUrl() already falls
     * back to the linked student's STUDENT_PHOTO, so the student row's own
     * studentFiles are only consulted on the legacy direct link, where there is
     * no request at all.
     */
    photo = () => {
        let fromRequest = getPhotoUrl(this.state.request);
        return fromRequest !== '' ? fromRequest : this.state.photo;
    }

    componentDidMount() {
        let id = this.props.student_id;
        if (id != undefined) {

            GetData(`/${id}/checkifidpaymentdone`)
                .then((resp1) => {
                    if (resp1 == true) {
                        this.setState({
                            paymentDone: true
                        })
                        GetData(`/${id}/getstudentbyid`)
                            .then((resp) => {
                                this.setState({
                                    isLoaded: true,
                                    student: resp,
                                    photo: this.getPhoto(resp.studentFiles),
                                    id: id
                                })
                            })
                    }else{
                        this.setState({
                            paymentDone: false
                        })
                    }
                })

            this.__getRequest();

        } else {
            this.props.history.goBack();
        }
    }

    __getRequest = () => {
        let request_id = this.props.request_id;
        if (!request_id || request_id === '' || !this.props.user) {
            return;
        }

        let apikey = this.props.user.user.apikey;
        let username = this.props.user.user.email;

        GetData(`/${apikey}/${username}/${request_id}/getidcardrequestsingle`)
            .then((resp) => {
                if (resp && resp.id) {
                    this.setState({ request: resp })
                }
            })
    }



    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', minHeight: '100vh' }}>

                {this.state.paymentDone == false && <div>Payment not done for this student</div>}

                {this.state.isLoaded && <div>
                    <ReactToPrint
                        trigger={() => {
                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                            // to the root node of the returned component as it will be overwritten.
                            return <Button variant='contained' >Print Now</Button>
                        }}
                        content={() => this.componentRef}
                    />
                    <br />


                    <div ref={el => (this.componentRef = el)} style={{display: 'flex', padding: '7px'}}>
                        <div style={{margin: '3px', marginRight: '10px'}}>
                        <div style={{ width: '105mm', height: '74mm', border: 'solid 2px black', backgroundColor: '#FEE9B4' }}>
                            <div style={{ backgroundColor: '#DA3C1F', height: '80px', position: 'relative' }}>
                                <div><img src="/rangia-ic-header.jpg" style={{ width: '100%', height: '160px' }} /></div>
                                <img
                                    src={this.photo()}
                                    style={{ width: '104px', height: '100px', objectFit: 'cover', objectPosition: 'top center', position: 'absolute', top: '54px', left: '146px', border: 'solid thin black' }}
                                />
                                <div style={{ position: 'absolute', top: 80, right: 20, fontSize: 9, fontWeight: 700, textAlign: 'center', color: 'white', lineHeight: 1 }}>DATE OF ISSUE<br />{(this.state.request && this.state.request.printed_on) ? this.state.request.printed_on : moment().format("DD-MM-YYYY")}</div>
                                <div style={{ position: 'absolute', top: '155px', width: '100%' }}>
                                    <div style={{ textAlign: 'center', fontSize: 12, fontWeight: 700 }}>{this.field('name')}</div>
                                    <div style={{ textAlign: 'center', fontSize: 9, fontWeight: 700, marginTop: -3 }}>{this.field('roll_no')}</div>

                                    <div style={{ paddingLeft: '20px' }}>
                                        <table width="100%">
                                            <tbody>
                                                <tr>
                                                    <td width="50%"><div style={{ fontSize: 9, fontWeight: 700 }}>C/o: {this.field('father_name')}</div></td>
                                                    <td width="50%"><div style={{ fontSize: 9, fontWeight: 700 }}>Class: {getGoodClass(this.field('course_code'), this.field('term'))}</div></td>
                                                </tr>
                                                <tr>
                                                    <td><div style={{ fontSize: 9, fontWeight: 700 }}>DOB: {this.field('date_of_birth') ? moment(this.field('date_of_birth'), "YYYY-MM-DD").format("DD-MM-YYYY") : ''}</div></td>
                                                    <td><div style={{ fontSize: 9, fontWeight: 700 }}>Contact: {this.field('phone')}</div></td>
                                                </tr>
                                                <tr>
                                                    <td ><div style={{ fontSize: 9, fontWeight: 700 }}>Address: {this.field('village')}</div></td>
                                                    <td><div style={{ fontSize: 9, fontWeight: 700 }}>PO: {this.field('post_office')}</div></td>
                                                </tr>
                                                <tr>
                                                    <td> <div style={{ fontSize: 9, fontWeight: 700 }}>Pin: {this.field('pin')}</div></td>
                                                    <td><div style={{ fontSize: 9, fontWeight: 700 }}>District: {this.field('district')},{this.field('state')}</div></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div style={{ paddingLeft: '20px' }}>
                                        <table width="100%">
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: 'left' }}><div style={{ fontSize: 9, fontWeight: 700 }}>
                                                        <br />
                                                        Signature of the Student
                                                    </div></td>
                                                    <td style={{ textAlign: 'right', paddingRight: 10 }}><div style={{ fontSize: 9, fontWeight: 700, position: 'relative' }}>
                                                        <img
                                                            src="/rc-009.png"
                                                            style={{ width: '80px', position: 'absolute', top: -30, right: -20 }}
                                                        />
                                                        <br />
                                                        Principal
                                                    </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>






                                </div>
                            </div>

                        </div>
                        </div>
                        
                        <div style={{margin: '3px'}}>
                        <div style={{ width: '105mm', height: '74mm', border: 'solid 2px black', padding: 10, position: 'relative' }}>
                            <div style={{ border: 'solid 1px grey', height: 70, marginBottom: 10 }}></div>
                            <div style={{ border: 'solid 1px grey', height: 125, padding: 10 }}>
                                <div style={{ textAlign: 'center', fontSize: 9, fontWeight: 700 }}>INSTRUCTIONS</div>
                                <ul style={{ fontSize: 7, fontWeight: 700 }}>
                                    <li >EVERY STUDENT MUST POSSESS THIS CARD AND PRODUCE ON DEMAND.</li>
                                    <li>IN THE EVENT OF LOSS OF THE CARD DUPLICATE WILL BE ISSUED ON PAYMENT OF RS. 100/-.</li>
                                    <li>PLEASE KEEP THIS CARD IN SAFE CUSTODY. THE LIBRARY WILL NOT BE HELD RESPONSIBLE.</li>
                                    <li>FOR ANY MISUSE OF THIS CARD. THE LOSS OF THE CARD MUST BE REPORTED TO THE COLLEGE AUTHORITY IMMEDIATELY.</li>
                                    <li>LIBRARY BOOKS ARE ISSUED FOR 15 DAYS ONLY. A FINE AS PER LIBRARY RULES WILL BE CHARGED FOR EACH VOLUME KEPT BEYOND THE DUE DATE.</li>
                                    <li>BOOK LOST, TURN OR DEFACED IN ANYWAY WILL HAVE TO BE PAID FOR BY THE BORROWERS. </li>
                                    <li>THIS CARD IS NOT TRANSFERABLE</li>
                                </ul>
                            </div>
                            <div>
                                <img src="/footer-rangia-back.jpg" style={{ width: '100%' }} />
                            </div>
                            <div style={{ position: 'absolute', top: 0, left: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <img src="/icon512.png" style={{ width: '50%', opacity: 0.3 }} />
                            </div>
                        </div>
                        </div>
                    </div>

                </div>}
            </div>
        )
    }
}
